import { Component, ErrorInfo, ReactNode } from 'react'
import { ErrorPage } from './ErrorPage'

interface Props {
 children: ReactNode
 fallback?: ReactNode
}

interface State {
 hasError: boolean
 error: Error | null
 errorInfo: ErrorInfo | null
}

export class ErrorBoundary extends Component<Props, State> {
 constructor(props: Props) {
 super(props)
 this.state = {
 hasError: false,
 error: null,
 errorInfo: null
 }
 }

 static getDerivedStateFromError(error: Error): State {
 return {
 hasError: true,
 error,
 errorInfo: null
 }
 }

 componentDidCatch(error: Error, errorInfo: ErrorInfo) {
 console.error('ErrorBoundary capturou um erro:', error, errorInfo)
 this.setState({
 error,
 errorInfo
 })
 }

 handleReset = () => {
 this.setState({
 hasError: false,
 error: null,
 errorInfo: null
 })
 }

 render() {
 if (this.state.hasError) {
 if (this.props.fallback) {
 return this.props.fallback
 }

 try {
 return (
 <ErrorPage
 error={this.state.error}
 errorInfo={this.state.errorInfo}
 onReset={this.handleReset}
 />
 )
 } catch (error) {
 // Fallback caso o ErrorPage também falhe
 console.error('Erro ao renderizar ErrorPage:', error)
 return (
 <div style={{
 minHeight: '100vh',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 backgroundColor: '#f3f4f6',
 padding: '20px',
 fontFamily: 'system-ui, -apple-system, sans-serif'
 }}>
 <div style={{
 maxWidth: '600px',
 width: '100%',
 backgroundColor: 'white',
 borderRadius: '8px',
 padding: '32px',
 boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
 textAlign: 'center'
 }}>
 <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', color: '#111827' }}>
 Ops! Algo deu errado
 </h1>
 <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '24px' }}>
 Ocorreu um erro inesperado. Por favor, recarregue a página.
 </p>
 <button
 onClick={() => window.location.reload()}
 style={{
 backgroundColor: '#3b82f6',
 color: 'white',
 border: 'none',
 borderRadius: '6px',
 padding: '10px 20px',
 fontSize: '14px',
 fontWeight: '500',
 cursor: 'pointer'
 }}
 >
 Recarregar Página
 </button>
 </div>
 </div>
 )
 }
 }

 return this.props.children
 }
}

